import { Text, Tabs, TabList, TabPanels, Tab, TabPanel, TabIndicator, Box } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { DashboardSection } from '../components/DashboardStyles';
import { oBIcons, userIcon } from '../components/Icons';
import Tasks from './Tasks';
import Meeting from './Meeting';
import Customer from './Customer';
// import Bargain from './Bargain';
import SampleRequest from './SampleRequest';
// import ProductReturns from './ProductReturns';
// import CustomSourcing from './CustomSourcing';
// import Report from './Report';

export default function Index() {
    const [activeTabIndex, setActiveTabIndex] = useState(0);

    // Get tab from URL params
    useEffect(() => {
        const param = new URLSearchParams(window.location.search);
        const tabParam = param.get('tab');

        if (tabParam) {
            const tabIndex = tabs.findIndex(
                (tab) => tab.label.toLowerCase().replace(/\s+/g, '') === tabParam.toLowerCase(),
            );
            if (tabIndex !== -1) {
                setActiveTabIndex(tabIndex);
            }
        } else {
            // Default to customers tab and update URL
            updateURL('customers');
        }
    }, []);

    const updateURL = (tabName) => {
        const url = new URL(window.location);
        url.searchParams.set('tab', tabName.toLowerCase().replace(/\s+/g, ''));
        window.history.pushState({}, '', url);
    };

    const handleTabChange = (index) => {
        setActiveTabIndex(index);
        const selectedTab = tabs[index];
        updateURL(selectedTab.label);
        console.log(selectedTab.label);
    };

    return (
        <DashboardSection>
            <Text fontSize="3xl" fontWeight="500" height="38px">
                CRM
            </Text>
            <Text marginBottom="1rem" color={'#667085'}>
                Manage customer relationships from one place
            </Text>
            <Box
                bg={'white'}
                borderRadius={'0.5rem'}
                paddingInline={{ base: '0px', lg: '1.25rem' }}>
                <Tabs index={activeTabIndex} onChange={handleTabChange}>
                    <Box
                        maxW={'100%'}
                        overflowX={'auto'}
                        className="no-scrollbar"
                        position={'relative'}>
                        <TabList>
                            {tabs.map((tab, index) => (
                                <Tab
                                    key={tab.label}
                                    color={'#667085'}
                                    _selected={{
                                        color: '#1B3B5F',
                                    }}
                                    gap="2">
                                    {tab.icon}
                                    <Text fontWeight={500} whiteSpace={'nowrap'}>
                                        {' '}
                                        {tab.label}
                                    </Text>
                                </Tab>
                            ))}
                        </TabList>
                        <TabIndicator mt="-5px" height="4px" bg="#1B3B5F" borderRadius="1px" />
                    </Box>
                    <TabPanels>
                        {tabs.map((tab) => (
                            <TabPanel key={tab.label}>{tab.component}</TabPanel>
                        ))}
                    </TabPanels>
                </Tabs>
            </Box>
        </DashboardSection>
    );
}

const tabs = [
      {
        icon: userIcon,
        label: 'Customers',
        component: <Customer />,
    },
    {
        icon: oBIcons.tasks,
        label: 'Tasks',
        component: <Tasks />,
    },
    {
        icon: oBIcons.meeting,
        label: 'Meetings',
        component: <Meeting />,
    },
    // {
    //     icon: oBIcons.quote,
    //     label: 'Quotes',
    //     component: <Quotes />,
    // },
  
    // {
    //     icon: oBIcons.bargain,
    //     label: 'Bargain',
    //     component: <Bargain />,
    // },
    {
        icon: oBIcons.sampleRequest,
        label: 'Sample Request',
        component: <SampleRequest />,
    },
    // {
    //     icon: oBIcons.quote,
    //     label: 'Product Returns',
    //     component: <ProductReturns />,
    // },
    // {
    //     icon: oBIcons.quote,
    //     label: 'Report',
    //     component: <Report />,
    // },
    // {
    //     icon: oBIcons.sampleRequest,
    //     label: 'Custom Sourcing',
    //     component: <CustomSourcing />,
    // },
];
